// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".zoomContainer__H5qDk{cursor:zoom-in}\n", "",{"version":3,"sources":["/home/runner/work/honeylove-web/honeylove-web/src/product_detail/components/ZoomWrapper.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAe","file":"ZoomWrapper.module.scss","sourcesContent":[".zoomContainer {\n  cursor: zoom-in;\n}\n"]}]);
// Exports
exports.locals = {
	"zoomContainer": "zoomContainer__H5qDk"
};
module.exports = exports;
